import React, { useState, useEffect } from "react";
import { Empty, Select } from "antd";

import moment from "moment";
import dayjs from 'dayjs';
import { Card, Col, Row, Tooltip, DatePicker, Tabs, Switch, Table } from "antd";
import ColumnChart from "../charts/ColumnChart";
import DoughNutChart from "../charts/DoughnutChart";
import PieChart from "../charts/PieChart";
import DistrictMap from "../charts/DistrictMap";
import ProvinceEventsMap from "../charts/ProvinceEventsMap";
import EventsMap from "../charts/EventsMap";

import Legend from "../charts/Legend";
import util from "../../utils/functions/custom";

import "antd/dist/reset.css";
import { InfoCircleTwoTone } from "@ant-design/icons";

import eventsAPI from "../../services/eventsAnalyticsService";
import lookupAPI from "../../services/commonLookupService";
import { ReportTemplate } from "../custom/ReportTemplate";
import { ReportButtons } from "../custom/ReportButtons";
import { reportTypeEnum } from "../custom/AppEnums";

export const EventsReport = (props) => {
  const { filterType } = props;

  const [ageData, setAgeData] = useState([]);
  const [raceData, setRaceData] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [disabilityData, setDisabilityData] = useState([]);
  const [participationTypeData, setParticipationTypeData] = useState([]);
  const [provincialDistributionData, setProvincialDistributionData] = useState([]);
  const [municipalDistributionData, setMunicipalDistributionData] = useState([]);
  const [provincialParticipationData, setProvincialParticipationData] = useState([]);
  const [municipalParticipationData, setMunicipalParticipationData] = useState([]);

  const [eventsGroupData, setEventsGroupData] = useState([]);
  const [eventsVenueTypeData, setEventsVenueTypeData] = useState([]);

  const [eventsData, setEventsData] = useState([]);
  const [eventDetails, setEventDetails] = useState({});
  const [showEventDetails, setshowEventDetails] = useState(false);

  const [reportYear, setReportYear] = useState(util.getCurrentRepotYear());
  const [financialYears, setFinancialYears] = useState(util.getCurrentFinancialYear());
  
  //const [currentDate, setcurrentDate] = useState(dayjs(Date()));
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [filterId, setFilterId] = useState();
  const [show, setShow] = useState(false);
  const [isGeo, setIsGeo] = useState(false);
  const [reportOutProps, setReportOutProps] = useState({
    data: [],
    color: "",
    type: "",
    year: 0,
    description: "",
    xLabel: "",
    yLabel: "",
  });

  const { Option } = Select;
  const eventsProvincialDistribution = "Distribution of Events by Province";
  const eventsMunicialDistribution = "Distribution of Events by Municipal District";
  const eventsProvincialParticipation = "Distribution of Event Participants by Province";
  const eventsMunicipalParticipation = "Distribution of Event Participants by Municipal District";

  const monthFormat = 'YYYY'

  useEffect(() => {
    setStartDate(reportYear);
    setEndDate(reportYear);
    getYearRange();
    initiateReportData(reportYear);
  }, [filterType]);

  const initiateReportData = (repYear) => {
    console.log("Filter type ", filterType);
    if (filterType === "venue") {
      getEventsVenueTypeData(repYear);
    } else if (filterType === "group") {
      getEventsGroupData(repYear);
    } else if (filterType === "event") {
      getEventsData(repYear);
    }
  }

  const getYearRange = async () => {
    try {
      const response = await eventsAPI.getYearRange();
      if (response && response.status === 200) {
        const { data } = response;
        setStartDate(data.startYear);
        setEndDate(data.endYear);
        const finYears = util.getFinancialYearRange(data.startYear, data.endYear);
        setFinancialYears(finYears);
        if (reportYear !== data.endYear) {
          setReportYear(data.endYear);
          initiateReportData(data.endYear);
        }
      } else {
        setStartDate(util.getCurrentRepotYear());
        setEndDate(util.getCurrentRepotYear());
      }
    } catch (error) { }
  };

  const getAgeReportData = async (year, filterId) => {
    try {
      const response = await eventsAPI.getAge(year, filterId, filterType);
      if (response && response.status === 200) {
        const { data } = response;
        setAgeData(data);
      } else {
        setAgeData([]);
      }
    } catch (error) { }
  };

  const getRaceData = async (year, filterId) => {
    try {
      const response = await eventsAPI.getRace(year, filterId, filterType);
      if (response && response.status === 200) {
        const { data } = response;
        setRaceData(data);
      } else {
        setRaceData([]);
      }
    } catch (error) { }
  };

  const getEventsVenueTypeData = async (repYear) => {
    try {
      const response = await lookupAPI.getEventTypes();
      if (response && response.status === 200) {
        const { data } = response;
        const allVenues = { key: -1, value: "All" };
        data.unshift(allVenues);
        setEventsVenueTypeData(data);
        setFilterId(allVenues.key);
        updateAnalytics(repYear, allVenues.key);
      } else {
        setEventsVenueTypeData([]);
      }
    } catch (error) { }
  };

  const getEventsData = async (repYear) => {
    try {
      const response = await eventsAPI.getEvents(repYear);
      if (response && response.status === 200) {
        const { data } = response;
        const selectedEvent = data[0];
        setFilterId(selectedEvent.id);
        setEventDetails(selectedEvent);
        setEventsData(data);
        updateAnalytics(repYear, selectedEvent.id);
      } else {
        setEventsData([]);
        setFilterId();
      }
    } catch (error) { }
  };

  const getEventsGroupData = async (repYear) => {
    try {
      const response = await lookupAPI.getEventGroups();
      if (response && response.status === 200) {
        const { data } = response;
        const allGroups = { key: -1, value: "All" };
        data.unshift(allGroups);
        setEventsGroupData(data);
        setFilterId(allGroups.key);
        updateAnalytics(repYear, allGroups.key);
      } else {
        setEventsGroupData([]);
      }
    } catch (error) { }
  };

  const getGenderData = async (year, filterId) => {
    try {
      const response = await eventsAPI.getGender(year, filterId, filterType);
      if (response && response.status === 200) {
        const { data } = response;
        setGenderData(data);
      } else {
        setGenderData([]);
      }
    } catch (error) { }
  };

  const getDisabilityData = async (year, filterId) => {
    try {
      const response = await eventsAPI.getDisability(year, filterId, filterType);
      if (response && response.status === 200) {
        const { data } = response;
        //  const  data  = disability1Data.filter((value) => value.year == year && value.value > 0);
        setDisabilityData(data);
      } else {
        setDisabilityData([]);
      }
    } catch (error) { }
  };

  const getParticipantsTypeData = async (year, filterId) => {
    try {
      const response = await eventsAPI.getParticipationType(year, filterId, filterType);
      if (response && response.status === 200) {
        const { data } = response;
        // const  data  = participationType1Data.filter((value) => value.year == year && value.value > 0);
        setParticipationTypeData(data);
      } else {
        setParticipationTypeData([]);
      }
    } catch (error) { }
  };

  const getProvincialDistributionData = async (year, filterId) => {
    try {
      const response = await eventsAPI.getProvincialDistribution(year, filterId, filterType);
      if (response && response.status === 200) {
        const { data } = response;
        setProvincialDistributionData(data);
      } else {
        setProvincialDistributionData([]);
      }
    } catch (error) { }
  };

  const getProvincialParticipationData = async (year, filterId) => {
    try {
      const response = await eventsAPI.getProvincialParticipation(year, filterId, filterType);
      if (response && response.status === 200) {
        const { data } = response;
        setProvincialParticipationData(data);
      } else {
        setProvincialParticipationData([]);
      }
    } catch (error) { }
  };

  const getMunicipalDistributionData = async (year, filterId) => {
    try {
      const response = await eventsAPI.getMunicipalDistribution(year, filterId, filterType);
      if (response && response.status === 200) {
        const { data } = response;
        setMunicipalDistributionData(data);
      } else {
        setMunicipalDistributionData([]);
      }
    } catch (error) { }
  };

  const getMunicipalParticipationData = async (year, filterId) => {
    try {
      const response = await eventsAPI.getMunicipalParticipation(year, filterId, filterType);
      if (response && response.status === 200) {
        const { data } = response;
        setMunicipalParticipationData(data);
      } else {
        setMunicipalParticipationData([]);
      }
    } catch (error) { }
  };

  const updateAnalytics = (repYear, filterId) => {
    getAgeReportData(repYear, filterId);
    getGenderData(repYear, filterId);
    getRaceData(repYear, filterId);
    getDisabilityData(repYear, filterId);
    getParticipantsTypeData(repYear, filterId);
    getProvincialDistributionData(repYear, filterId);
    getMunicipalDistributionData(repYear, filterId);
    getProvincialParticipationData(repYear, filterId);
    getMunicipalParticipationData(repYear, filterId);
  };

  const onYearChange = (value) => {
    //let repYear = dayjs(value).format("YYYY");
   // setReportYear(repYear);
    //setcurrentDate(dayjs(value))
    setReportYear(value);
    if (filterType === "event") {
      getEventsData(value);
    } else {
      updateAnalytics(value, filterId);
    }
  };

  const onChangeEventGroup = (selectedGroup) => {
    // const selectedType = eventsGroupData.find((record) => record.key === selected);
    setFilterId(selectedGroup);
    updateAnalytics(reportYear, selectedGroup);
  };

  const onChangeSwitch = (checked) => {

    if (checked) setshowEventDetails(true)
    else setshowEventDetails(false)
  };

  const onChangeEventId = (selected) => {
    const selectedEvent = eventsData.find((record) => record.id === selected);
    setFilterId(selectedEvent.id);
    setEventDetails(selectedEvent);
    updateAnalytics(reportYear, selectedEvent.id);
  };

  const onChangeVenueType = (selectedType) => {
    // const selectedType = eventsVenueTypeData.find((record) => record.key === selected);
    setFilterId(selectedType);
    updateAnalytics(reportYear, selectedType);
  };

  // Disable some dates on the picker based on start and end dates
  const disabledDate = (current) => {
    return (
      current &&
      (current.valueOf() >= moment(endDate + 1, "YYYY") ||
        current.valueOf() <= moment(startDate, "YYYY"))
    );
  };

  const onTabChange = (key) => {

    switch (key) {
      case "2":
        getProvincialDistributionData(reportYear, filterId);
        getMunicipalDistributionData(reportYear, filterId);
        break;
      case "3":
        getProvincialParticipationData(reportYear, filterId);
        getMunicipalParticipationData(reportYear, filterId);
        break;
      default:
        break;
    }
  };

  const handlePrint = (
    color,
    data,
    type,
    desc,
    title,
    xLabel = "None",


  ) => {
    const rptProps = { ...reportOutProps };
    rptProps.color = color;
    rptProps.data = data;
    rptProps.type = type;
    rptProps.year = reportYear ? reportYear : 0;
    rptProps.description = desc;
    rptProps.title = title;
    rptProps.xLabel = xLabel;
    setReportOutProps(rptProps);
    setShow(true);
    setIsGeo(false);
  };

  const handleGeoPrint = (title, description, data, geoType, dataSource) => {
    const rptProps = { ...reportOutProps };
    rptProps.title = title;
    rptProps.description = description;
    rptProps.color = undefined;
    rptProps.data = data;
    rptProps.type = geoType;
    rptProps.year = reportYear ? reportYear : 0;
    rptProps.dataSource = dataSource;

    setReportOutProps(rptProps);
    setShow(true);
    setIsGeo(true);
  };

  const handlePrintCancel = () => {
    setShow(false);
    setIsGeo(false);
    const rptProps = { ...reportOutProps };
    rptProps.title = "";
    rptProps.description = "";
    rptProps.color = undefined;
    rptProps.data = [];
    rptProps.type = undefined;
    rptProps.year = 0;
    rptProps.dataSource = "";
    setReportOutProps(rptProps);
  };
  const handleDataDownload = (data, filename, chartType) => {
    let csvContent;

    if (chartType === reportTypeEnum.GROUPCOL) {
      const groupedData = util.groupDataByType(data, reportYear);

      csvContent =
        "data:text/csv;charset=utf-8," +
        util.convertArrayDataToCSV(groupedData);
    } else {
      csvContent =
        "data:text/csv;charset=utf-8," + util.convertArrayDataToCSV(data);
    }

    const encodedURI = encodeURI(csvContent);

    //Allow the selected to be downloadable through an anchor popup
    const link = document.createElement("a");
    link.setAttribute("href", encodedURI);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const columns = [
    {
      title: 'Title',
      dataIndex: 'name',
    },
    {
      title: 'Details',
      dataIndex: 'age',
    },
  ];
  const data = [
    {
      key: '1',
      name: 'Event date',
      age: eventDetails.dates,
    },
    {
      key: '2',
      name: 'Event group',
      age: eventDetails.group,
    },
    {
      key: '3',
      name: 'Event type',
      age: eventDetails.type,
    },
    {
      key: '4',
      name: 'Event venue',
      age: eventDetails.venue,
    },
    {
      key: '5',
      name: 'Host organisation',
      age: eventDetails.hostOrganisation,
    },
    {
      key: '6',
      name: 'Event description ',
      age: eventDetails.description,
    },
    {
      key: '7',
      name: 'Total number of participants ',
      age: eventDetails.totalParticipants,
    },
  ];
  function Tab1() {
    return (
      <div className="report-content">

        <Row style={{ paddingBottom: 20 }} gutter={16}>
          {/* <Col xs  */}
          <Col xs={24} md={8}>
            <Card
              title="Participants Disability Distribution"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Demographic analysis of events participants, based on disability.">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                disabilityData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "demographicPie",
                        disabilityData,
                        reportTypeEnum.DOUGHNUT,
                        "Demographic analysis of events participants, based on disability.",
                        "Participants Disability Distribution"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        disabilityData,
                        "Participants Disability Distribution",
                        reportTypeEnum.DOUGHNUT
                      )
                    }
                  />,
                ]
              }
            >
              {disabilityData.length === 0 ? (
                <Empty />
              ) : (
                <DoughNutChart data={disabilityData.filter(item => item.value > 0)} color="demographicPie" type ="Disability" />
              )}
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card
              title="Participants Race Distribution"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Demographic analysis of events participants, based on race.">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                raceData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "raceDoughnut",
                        raceData,
                        reportTypeEnum.DOUGHNUT,
                        "Demographic analysis of events participants, based on race.",
                        "Participants Race Distribution"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        raceData,
                        "Participants Race Distribution",
                        reportTypeEnum.DOUGHNUT
                      )
                    }
                  />,
                ]
              }
            >
              {raceData.length === 0 ? (
                <Empty />
              ) : (
                <DoughNutChart data={raceData.filter(item => item.value > 0)} color="raceDoughnut" type ="Race"/>
              )}
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card
              title="Participants Gender Distribution"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Demographic analysis of events participants, based on gender.">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                genderData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "csGender",
                        genderData,
                        reportTypeEnum.DOUGHNUT,
                        "Demographic analysis of events participants, based on gender.",
                        "Participants Gender Distribution"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        genderData,
                        "Participants Gender Distribution",
                        reportTypeEnum.DOUGHNUT
                      )
                    }
                  />,
                ]
              }
            >
              {genderData.length === 0 ? (
                <Empty />
              ) : (
                <DoughNutChart data={genderData.filter(item => item.value > 0)} color="csGender"  type ="Gender"/>
              )}
            </Card>
          </Col>
        </Row>
        <Row style={{ paddingBottom: 20 }} gutter={16}>
          <Col xs={24} md={12}>
            <Card
              title="Participants Age Groups"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Demographic analysis of events participants, based on age.">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                ageData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "ageGroups",
                        ageData,
                        reportTypeEnum.COLUMN,
                        "Demographic analysis of events participants, based on age.",
                        "Participants Age Groups",
                        "Participants per age group",
                        "Number per age group"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        ageData,
                        "Participants Age Groups",
                        reportTypeEnum.COLUMN
                      )
                    }
                  />,
                ]
              }
            >
              {ageData.length === 0 ? (
                <Empty />
              ) : (
                <ColumnChart
                  data={ageData.filter(item => item.value > 0)}
                  xLabel="type"
                  yLabel="value"
                  // color="#2e84bf"
                  color="ageGroups"
                  xAxisLabel="Participants per age group"
                  yAxisLabel="Number per age group"
                />
              )}
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card
              title="Participants Type Distribution"
              bordered={false}
              style={{ height: "auto" }}
              extra={
                <Tooltip title="Demographic analysis of events participants, based on participant type.">
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                participationTypeData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handlePrint(
                        "typeDistribution",
                        participationTypeData,
                        reportTypeEnum.COLUMN,
                        "Demographic analysis of events participants, based on participant type.",
                        "Participants Type Distribution",
                        "Participants per type",
                        "Number per participant type"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        participationTypeData,
                        "Participants Type Distribution",
                        reportTypeEnum.COLUMN
                      )
                    }
                  />,
                ]
              }
            >
              {participationTypeData.length === 0 ? (
                <Empty />
              ) : (
                <ColumnChart
                  data={participationTypeData.filter(item => item.value > 0)}
                  xLabel="type"
                  yLabel="value"
                  // color="#32669e"
                  color="typeDistribution"
                  xAxisLabel="Participants per type"
                  yAxisLabel="Number per participant type"
                />
              )}
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
  function Tab3() {
    return (
      <div className="report-content map">
        <Row span={25} style={{ paddingBottom: 40 }} gutter={16}>
          <Col xs={24} md={24}>
            <Card
              title="Geographic distribution of events/activities in terms of Provinces"
              bordered={false}
              style={{ height: "auto" }}
              className="nysOrigin"
              extra={
                <Tooltip title={eventsProvincialDistribution}>
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                provincialDistributionData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handleGeoPrint(
                        "Geographic distribution of events/activities in terms of Provinces",
                        eventsProvincialDistribution,
                        provincialDistributionData,
                        reportTypeEnum.GEO_PROVINCES,
                        "Events"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        provincialDistributionData,
                        eventsProvincialDistribution,
                        reportTypeEnum.GEO_PROVINCES
                      )
                    }
                  />
                ]
              }
            >
              <ProvinceEventsMap
                data={provincialDistributionData}
                hoverText={eventsProvincialDistribution}
                dataSource={"Events"}
              />
              <Legend />
            </Card>
          </Col>
        </Row>
        <Row span={25} style={{ paddingBottom: 30 }} gutter={16}>
          <Col xs={24} md={24}>
            <Card
              title="Geographic distribution of events/activities in terms of Municipal boundaries"
              bordered={false}
              style={{ height: "auto" }}
              className="nysOrigin"
              extra={
                <Tooltip title={eventsMunicialDistribution}>
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                municipalDistributionData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handleGeoPrint(
                        "Geographic distribution of events/activities in terms of Provinces",
                        eventsMunicialDistribution,
                        municipalDistributionData,
                        reportTypeEnum.GEO_MUNICIPALS,
                        "Events"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        municipalDistributionData,
                        eventsMunicialDistribution,
                        reportTypeEnum.GEO_MUNICIPALS
                      )
                    }
                  />,
                ]
              }
            >
              <DistrictMap
                data={municipalDistributionData}
                hoverText={eventsMunicialDistribution}
                dataSource={"Events"}
              />
              <Legend />
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
  function Tab4() {
    return (
      <div>
        <Row
          span={25}
          style={{ paddingBottom: 20 }}
          gutter={16}
          className="report-content map"
        >
          <Col xs={24} md={24}>
            <Card
              title="Geographic distribution of participants in terms of Provinces"
              bordered={false}
              style={{ height: "auto" }}
              className="nysOrigin"
              extra={
                <Tooltip title={eventsProvincialParticipation}>
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                provincialParticipationData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handleGeoPrint(
                        "Geographic distribution of participants in terms of Provinces",
                        eventsProvincialParticipation,
                        provincialParticipationData,
                        reportTypeEnum.GEO_PROVINCES,
                        "Participants"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        provincialParticipationData,
                        eventsProvincialParticipation,
                        reportTypeEnum.GEO_PROVINCES
                      )
                    }
                  />,
                ]
              }
            >
              <ProvinceEventsMap
                data={provincialParticipationData}
                hoverText={eventsProvincialParticipation}
                dataSource="Participants"
              />
              <Legend />
            </Card>
          </Col>
        </Row>
        <Row
          span={25}
          style={{ paddingBottom: 20 }}
          gutter={16}
          className="report-content map"
        >
          <Col xs={24} md={24}>
            <Card
              title="Geographic distribution of participants in terms of Municipal boundaries test"
              bordered={false}
              style={{ height: "auto" }}
              className="nysOrigin"
              extra={
                <Tooltip title={eventsMunicipalParticipation}>
                  <InfoCircleTwoTone />
                </Tooltip>
              }
              actions={
                municipalParticipationData.length > 0 && [
                  <ReportButtons
                    onPrint={() =>
                      handleGeoPrint(
                        "Geographic distribution of participants in terms of Municipal boundaries",
                        eventsMunicipalParticipation,
                        municipalParticipationData,
                        reportTypeEnum.GEO_MUNICIPALS,
                        "Participants"
                      )
                    }
                    onDownload={() =>
                      handleDataDownload(
                        municipalParticipationData,
                        eventsMunicipalParticipation,
                        reportTypeEnum.GEO_MUNICIPALS
                      )
                    }
                  />
                ]
              }
            >
              <DistrictMap
                data={municipalParticipationData}
                hoverText={eventsMunicipalParticipation}
                dataSource={"Participants"}
              />
              <Legend />
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
  
  const tabList = [
    {
      key: "1",
      label: "Participant demographic distribution",
      children: <Tab1 />,
    },
    {
      key: "2",
      label: "Event geographic distribution",
      children: <Tab3 />,
      eventGeo: true
    },
    {
      key: "3",
      label: "Participant geographic distribution",
      children: <Tab4 />,
    },

  ].filter((item) => {
    return props.eventType === "Venue Type" ? item : props.eventType === "Group Event" ? item : item.eventGeo === undefined;
  });

  return (
    <>
      <div className="report-nys-content">
        <h2 className="report-heading">{`${props.eventType} Report`}</h2>
        <div className="reportYear">
          <Row
            style={{
              borderRadius: "10px",
            }}
          >
            <Col
              xs={11}
              md={11}
              style={{
                borderRadius: "10px",
              }}
            >
              <div className="reportYearContainer">
                <div
                  style={{
                    margin: "0px auto",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  Financial year : &nbsp;
                  {/* <DatePicker
                    picker="year"
                    onChange={onYearChange}
                    disabledDate={disabledDate}
                    defaultValue={dayjs((reportYear).toString(), monthFormat)}
                    format={monthFormat}
                    allowClear={false}
                  /> */}
                   <Select
                    // style={{ width: "65%" }}
                    placeholder="Please select financial year"
                    onChange={onYearChange}
                    loading={!financialYears.length}
                    value={reportYear}
                    size="large"
                  >
                    {financialYears?.map((year) => {
                      return (
                        <Option key={year.id} value={year.id}>
                          {year.value}
                        </Option>
                      );
                    })}
                  </Select>
                </div>
              </div>
            </Col>
            {props.eventType === "Venue Type" && (
              <Col xs={12} md={12} lg={11}>
                <div className="report-venue-type">
                  <div
                    style={{
                      margin: "10px auto 0px auto",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    Select event venue type :{" "}
                    <Select
                      style={{ width: "65%" }}
                      placeholder="Please select event venue type"
                      onChange={onChangeVenueType}
                      value={filterId}
                    >
                      {eventsVenueTypeData.map((event) => {
                        return (
                          <Option key={event.key} value={event.key}>
                            {event.value}
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                </div>
              </Col>
            )}
            {props.eventType === "Individual Event" && (
              <>
                <Col xs={8} md={7} lg={9}>
                  <div className="report-venue-type">
                    <div
                      style={{
                        margin: "10px auto 0px auto",
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      Select event:{" "}
                      <Select
                        style={{ width: "65%" }}
                        placeholder="Please select event"
                        onChange={onChangeEventId}
                        value={filterId}
                      >
                        {eventsData.map((event) => {
                          return (
                            <Option key={event.id} value={event.id}>
                              {event.name + ' (' + event.dates + ')'}
                            </Option>
                          );
                        })}
                      </Select>
                    </div>
                  </div>
                </Col>
                <Col xs={4} md={4}>
                  <div className="reportMetadata">
                    Show event details:{" "}
                    <Switch
                      onChange={onChangeSwitch} />
                  </div>
                </Col>
              </>
            )}
            {props.eventType === "Event Group" && (
              <Col xs={12} md={12} lg={11}>
                <div className="report-venue-type">
                  <div
                    style={{
                      margin: "10px auto 0px auto",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                  >
                    Select event group:{" "}
                    <Select
                      style={{ width: "65%" }}
                      placeholder="Please select event group"
                      onChange={onChangeEventGroup}
                      value={filterId}
                    >
                      {eventsGroupData.map((event) => {
                        return (
                          <Option key={event.key} value={event.key}> {event.value}</Option>);
                      })}
                    </Select>
                  </div>
                </div>
              </Col>
            )}
          </Row>
        </div>
        <br />
        <Row style={{ display: showEventDetails ? 'block' : 'none' }}>
          <Col xs={24} md={14} lg={14} offset={5}>
            <Table columns={columns} dataSource={data} pagination={false} size="small" />
          </Col>
        </Row>
      </div>
      <div className="space"></div>
      <Tabs
        type="card"
        onChange={onTabChange}
        items={tabList}
        className="report-tabs"
        key="1"
      />
      <ReportTemplate
        onCancel={handlePrintCancel}
        reportOutProps={reportOutProps}
        show={show}
        key="reportTemplateEvents"
        isGeo={isGeo}
      />
    </>
  );
};
